module.exports = __webpack_public_path__ + "media/images/riders/small/SABINE_SPITZ-7e145e74f41ae314a0c592b90495ccca.png";